export default __webpack_public_path__ + "static/media/bbq.8fd7f846.jpg";